import React from "react";
import { connect } from "react-redux";
import Refresh_icon from '../assets/img/refresh.svg'
import ListIcon from '../assets/img/navi/list'
import DashboardIcon from '../assets/img/navi/dashboard'
import SettingIcon from '../assets/img/navi/setting'
import ArrowIcon from '../assets/img/navi/arrow';
import HistoryIcon from '../assets/img/navi/history';
import ToggleMenu from '../assets/img/navi/toggleMenu';
import NavLogo from '../assets/img/navLogo.svg';
import Logo from '../assets/img/logo.svg'
import Logo_full from '../assets/img/logo_full.svg'
import constants from '../lib/constants/constants'
import cookie from 'react-cookies'
import commonMethod from '../lib/commonMethod'
import $ from 'jquery'

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isClose: false,
            active: "",
            title: "",
            showUserInfo: false,
            isAnimation: false,
            showRefresh: false,
            toggleMenu: false,
            client: null,
            url: process.env.REACT_APP_URL,
            demo: false,
        }
        this.accessToken = cookie.load('accessToken')
        this.toggleNavigation = this.toggleNavigation.bind(this);
        this.handleUsername = this.handleUsername.bind(this);
    }

    componentDidMount() {
        if (window.location.href.indexOf("demo") !== -1) {
            this.setState({ demo: true });
            this.props.setUserName("demo");
            this.setState({ showRefresh: true })
        }
        let auto = { value: false };
        if (localStorage.getItem('accessToken')) {
            auto = JSON.parse(localStorage.getItem('accessToken'));
        }
        if (window.location.pathname === "/" && (cookie.load('autoLogin') || auto.value)) {
            this.getActiveTab("square.hej.so/list");
        } else { this.getActiveTab(window.location.href); }

        if (window.location.href.indexOf("demo") === -1) {
            this.getUserInfo();
        }
        this.checkNavigaion();
        this.setState({ showRefresh: true });
        window.addEventListener('click', (e) => this.handleClick(e));
        $(window).scroll(function () {
            $('.header').css('left', -$(window).scrollLeft() + "px");
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.client !== this.state.client) {
            this.setState({ client: this.state.client });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(nextState.showRefresh === this.state.showRefresh &&
            nextState.toggleMenu === this.state.toggleMenu &&
            nextState.isClose === this.state.isClose &&
            nextState.showUserInfo === this.state.showUserInfo);

    }

    checkNavigaion() {
        // 네비게이션 open/close 체크
        if (cookie.load('isCloseNavi')) {
            this.props.setNavigationWidth(60);
            this.setState({ isClose: true })
        }
    }

    handleClick(e) {
        //사용자 팝업 focusout event
        if (!e.target.className || e.target.className !== "user-name") {
            this.setState({ showUserInfo: false })
        }
    }

    getUserInfo(active) {
        // 유저정보 API 호출
        if (active && this.accessToken) {
            commonMethod.requestGetWithToken('dashboard/config/user', this.accessToken, this, res => {
                this.props.setUserName(res.member[0].name);
                this.setState({ showRefresh: true })
            });
        } else if (window.location.href.indexOf('code') !== -1) {
            this.setState({ showRefresh: true })
        }
    }

    checkAccessToken(active) {
        // accessToken 빈 경우 로그아웃 처리
        let url = window.location.href;
        let accessToken = "";
        if (localStorage.getItem('accessToken')) {
            accessToken = JSON.parse(localStorage.getItem('accessToken'))
        }
        let localAccess = false;
        if (accessToken.value === null || accessToken.value === "undefined" || accessToken.value === undefined) {
            localAccess = true;
        }
        if (active && url.indexOf('code') === -1) {
            if (!cookie.load('accessToken') && localAccess) {
                this.logout();
            }
        }
    }

    getActiveTab(page) {
        // 내비게이션 탭 active 구분과 헤더 타이틀 작업 
        let tab = "";
        let title = "";
        page = page.substring(14);
        if (page.indexOf('list') !== -1) {
            tab = "list";
            title = "장소 리스트";
        } else if (page.indexOf('square') !== -1) {
            tab = "dashboard";
            title = "";
        } else if (page.indexOf('camera') !== -1) {
            tab = "camera";
            title = "보안카메라";
        } else if (page.indexOf('history') !== -1) {
            tab = "history";
        } else if (page.indexOf('userDashboard') !== -1) {
            tab = "userDashboard";
        } else if (page.indexOf('setting') !== -1) {
            tab = "setting";
            title = "설정";
        } else if (page.indexOf('error') !== -1) {
            tab = "error";
            title = "";
        } if (page.indexOf('demolist') !== -1) {
            tab = "demolist";
            title = "데모 장소 리스트";
        } else if (page.indexOf('demosquare') !== -1) {
            tab = "demodashboard";
            title = "";
        } else if (page.indexOf('history') !== -1) {
            tab = "history";
            title = "히스토리";
        }
        this.setState({ active: tab, title: title });
        // 토큰 비었는지 체크

        if (page.indexOf("demo") === -1) {
            this.checkAccessToken(tab)
            this.getUserInfo(tab)
        }
    }

    logout(e) {
        // 로그아웃(쿠키 reset 후 로그인 페이지로 이동)
        if (e) this.preventEvent(e);
        localStorage.clear();
        cookie.remove('accessToken', { path: '/' });
        cookie.remove('username', { path: '/' });
        cookie.remove('autoLogin', { path: '/' });
        window.location.href = constants.URL.LOGIN;
    }

    preventEvent(e) {
        e.stopPropagation();
        e.preventDefault();
        e.returnValue = false;
    }

    toggleNavigation() {
        // 좌측 내비게이션 open/close 제어
        this.setState({ isClose: !this.state.isClose, isAnimation: true });
        if (this.state.isClose) {
            this.props.setNavigationWidth(220);
            cookie.remove('isCloseNavi', { path: '/' });

        } else {
            this.props.setNavigationWidth(60);
            cookie.save('isCloseNavi', true, { path: "/" });
        }

        setTimeout(function () {
            this.setState({ isAnimation: false });
        }.bind(this), 500);
    }

    handleUsername(e) {
        if (e.target.className && e.target.className === "user-name") {
            this.setState((state) => {
                return { showUserInfo: !state.showUserInfo };
            })
        }
    }

    render() {
        return (
            <div className="hejhome">
                {this.state.active &&
                    <React.Fragment>
                        <div className="header">
                            <h2 className={this.state.isClose ? "close" : ""}>
                                {this.state.title}
                            </h2>
                            <div className="user-info-wrap">
                                <h3 onClick={(e) => this.handleUsername(e)} className="user-name">
                                    {this.props.userName ? this.props.userName : cookie.load('username')}
                                    {this.state.showUserInfo &&
                                        <div className="user-info-box"
                                        onClick={(e) => this.preventEvent(e)}>
                                            <div className="logo-wrap">       
                                                <img src={Logo} alt=""/>
                                            </div>
                                            <div className="info-wrap">
                                                <h4>{this.props.userName ? this.props.userName : cookie.load('username')}</h4>
                                                {!this.state.demo && <h5>{cookie.load('username')}</h5>}
                                                <p className="btn active"
                                                    onClick={(e) => this.logout(e)}>
                                                    로그아웃
                                                    </p>
                                            </div>
                                        </div>
                                    }
                                </h3>
                            </div>
                            <button onClick={() => this.props.setIsRefresh(true)}>
                                {this.state.showRefresh && <img src={Refresh_icon} alt=""/>}
                            </button>
                        </div>
                        {!this.state.demo &&
                            <div className={this.state.isClose ? "navigation close" : "navigation"}>
                                <section>
                                    <h1 className="logo-wrap">
                                        {this.state.isClose ? 
                                            <img src={NavLogo} className="logo" alt="logo" /> : 
                                            <img src={Logo_full} className="logo" alt="logo" />
                                        }
                                    </h1>
                                    <ul className="menu-list">
                                        <li className={this.state.active === "list" ? "active" : ""}>
                                            <a href={constants.URL.LIST}>
                                                <ListIcon />
                                                <span>장소 리스트</span>
                                            </a>
                                        </li>
                                        <li className={this.state.active === "dashboard" ? "active" : ""}>
                                            <a href={constants.URL.DASHBOARD}>
                                                <DashboardIcon />
                                                <span>대시보드</span>
                                            </a>
                                        </li>
                                        <li className={this.state.active === "history" ? "active" : ""}>
                                            <a href={constants.URL.HISTORY}>
                                                <HistoryIcon />
                                                <span>히스토리</span>
                                            </a>
                                        </li>
                                        {/*
                                    <li className={this.state.active ==="camera" ? "active" : ""}>
                                        <a href={constants.URL.CAMERA}>
                                            <Camera_icon/>
                                            <span>보안카메라</span>
                                        </a>
                                    </li> 
                                        */}
                                        <li className={this.state.active === "setting" ? "active" : ""}>
                                            <a href={constants.URL.SETTING}>
                                                <SettingIcon />
                                                <span>설정</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <p className="toggle-menu"
                                        onClick={() => {
                                            this.setState((state) => {
                                                return { isClose: !state.isClose };
                                            }); this.toggleNavigation()
                                        }}
                                       onMouseEnter={() => this.setState({ toggleMenu: true })}
                                       onMouseLeave={() => this.setState({ toggleMenu: false })}
                                    >
                                        {this.state.toggleMenu ? <ArrowIcon close={this.state.isClose} /> : <ToggleMenu />}
                                    </p>
                                </section>
                            </div>
                        }
                        {this.state.demo &&
                            <div className={this.state.isClose ? "navigation close" : "navigation"}>
                                <section>
                                    <h1 className="logo-wrap">
                                        {this.state.isClose ? 
                                            <img src={NavLogo} className="logo" alt="logo" /> : 
                                            <img src={Logo_full} className="logo" alt="logo" />
                                        }
                                    </h1>
                                    <ul className="menu-list">
                                        <li className={this.state.active === "demolist" ? "active" : ""}>
                                            <a href={constants.URL.DEMOLIST}>
                                                <ListIcon />
                                                <span>데모 장소 리스트</span>
                                            </a>
                                        </li>
                                        <li className={this.state.active === "demodashboard" ? "active" : ""}>
                                            <a href={constants.URL.DEMODASHBOARD}>
                                                <DashboardIcon />
                                                <span>데모 대시보드</span>
                                            </a>
                                        </li>
                                        <li></li>
                                    </ul>
                                    <p
                                        className="toggle-menu"
                                        onClick={() => {
                                            this.setState((state) => {
                                                return { isClose: !state.isClose }
                                            });
                                            this.toggleNavigation()
                                        }}
                                        onMouseEnter={() => this.setState({ toggleMenu: true })}
                                        onMouseLeave={() => this.setState({ toggleMenu: false })}
                                    >
                                        {this.state.toggleMenu ? <ArrowIcon close={this.state.isClose} /> : <ToggleMenu />}
                                    </p>
                                </section>
                            </div>
                        }
                    </React.Fragment>
                }
                <div className={this.state.isClose ? "page-wrap close" : "page-wrap"}>
                  {this.props.children}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken,
        isRefresh: state.hejhome.isRefresh,
        userName: state.hejhome.userName,
        navigationWidth: state.hejhome.navigationWidth,
    }
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
    setIsRefresh: (bool) => dispatch({
        type: 'setIsRefresh',
        isRefresh: bool,
    }),
    setUserName: (name) => dispatch({
        type: 'setUserName',
        userName: name,
    }),
    setNavigationWidth: (width) => dispatch({
        type: 'setNavigationWidth',
        navigationWidth: width,
    }),
});

Layout = connect(mapStateToProps, mapDispatchToProps)(Layout);

export default Layout;

